import React from 'react';
import ReactDOM from 'react-dom';

interface IPortalProps {
  selector: string;
}

const noopSubscribe = () => () => {};

export const Portal: React.FC<React.PropsWithChildren<IPortalProps>> = (
  props
) => {
  const element = React.useSyncExternalStore(
    noopSubscribe,
    () => (document && document.querySelector(props.selector)) || null,
    () => null
  );
  return element && props.children
    ? ReactDOM.createPortal(props.children, element)
    : null;
};
